const INVALID_PATH_SEGMENTS = new Set(['undefined', 'null', 'NaN'])

export const combineApiPath = (baseURL = '', url = '') => {
  const path = String(url || '').split('?')[0]
  const base = String(baseURL || '').split('?')[0]

  if (!base) {
    return path
  }

  if (!path) {
    return base
  }

  return `${base.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`
}

export const findInvalidPathSegment = (pathname) => {
  const segments = String(pathname || '')
    .replace(/^\//, '')
    .replace(/\/$/, '')
    .split('/')

  return segments.find((segment) => !segment || INVALID_PATH_SEGMENTS.has(segment))
}

export const assertValidRequestUrl = (config = {}) => {
  const path = combineApiPath(config.baseURL, config.url)
  const invalidSegment = findInvalidPathSegment(path)

  if (invalidSegment == null) {
    return null
  }

  return {
    path,
    invalidSegment,
  }
}
